import React from 'react';
import PropTypes from 'prop-types';

const AlertMessage = props => {
  if (typeof props.msg === 'string' && props.msg.indexOf('<script') === -1) {
    return <div className="pxl-alert__message" dangerouslySetInnerHTML={{ __html: props.msg }} />;
  } 
  return <div className="pxl-alert__message">{props.msg}</div>;
  
};

AlertMessage.propTypes = {
  msg: PropTypes.any
};

export default AlertMessage;
